<app-header></app-header>
<!-- ======= Hero Section ======= -->
<section id="hero" class="d-flex flex-column justify-content-end align-items-center">
    <div id="heroCarousel" class="container carousel carousel-fade" data-ride="carousel">

        <!-- Login -->
        <div class="carousel-item active">
            <div class="carousel-container" style="height: 100%;">
                <h2 class="m-4 animate__animated animate__faster animate__fadeInDown" style="margin-bottom: 0px;">
                    Ingreso seguro
                </h2>
                <div>
                    <div class="container" style="max-width: 300px;">
                        <ng-lottie [options]="Login" (animationCreated)="animationCreated($event)">
                        </ng-lottie>
                    </div>
                    <div id="loader" class="d-none animate__animated animate__faster">
                        <app-loader></app-loader>
                    </div>
                    <div id="form-login" class="animate__animated animate__faster">
                        <div class="form-group animate__animated animate__faster animate__fadeInRight">
                            <input type="email" (keyup.enter)="onSubmit()" class="form-control" id="Email" placeholder="Ingrese su email">
                        </div>
                        <div class="form-group animate__animated animate__faster animate__fadeInLeft">
                            <input type="password" (keyup.enter)="onSubmit()" class="form-control" id="Password" placeholder="Clave de acceso">
                        </div>
                        <a data-target="#resetPassword" data-toggle="modal"><p style="font-size: 0.7rem;margin-top: 0;margin-bottom: 0;">¿Has olvidado tu contraseña?</p></a>
                        <a (click)="onSubmit()"
                            class="btn-get-started animate__animated animate__faster animate__fadeInUp">
                            <i class="icofont-login"></i>&nbsp;Aceptar
                        </a>                        
                    </div>
                    <div class="w-full txt-center m-v-20 fl fl-center">
                        <hr class="fl-1" color="white" style="border-bottom: 1px;"><span class="p-h-15"
                            style="color: #42494f; font-size: 16px;color:white;">or</span>
                        <hr class="fl-1" color="white" style="border-bottom: 1px;">
                    </div>
                    <a class="google-link">
                        <button (click)="authWithGoogle()" type="button" class="buttonGoogle google-auth fl-row w-full m-v-15">
                            <div class="logo"></div>
                            <div class="text-container">
                                <div class="text">Log in with Google</div>
                            </div>
                        </button>
                    </a>
                </div>
            </div>
        </div>
    </div>



    <svg class="hero-waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 24 150 28 " preserveAspectRatio="none">
        <defs>
            <path id="wave-path" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
        </defs>
        <g class="wave1">
            <use xlink:href="#wave-path" x="50" y="3" fill="rgba(255,255,255, .1)" />
        </g>
        <g class="wave2">
            <use xlink:href="#wave-path" x="50" y="0" fill="rgba(255,255,255, .2)" />
        </g>
        <g class="wave3">
            <use xlink:href="#wave-path" x="50" y="9" fill="#fff" />
        </g>
    </svg>

</section><!-- End Hero -->

    <!-- Modal -->
    <div class="modal fade" id="resetPassword" tabindex="-1" role="dialog"
        aria-labelledby="crearLabel" aria-hidden="true">
        <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="crearLabel">¿Has olvidado tu contraseña?</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form>
                    <div class="modal-body">
                        <div class="form-group">
                            <label for="exampleInputEmail1">Introduzca su Email</label>
                            <input type="email" class="form-control" id="resetPasswordEmail" aria-describedby="emailHelp" placeholder="Enter email">
                          </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" id="CloseModal" class="btn btn-secondary"
                            data-dismiss="modal">Cerrar</button>
                        <button type="button" (click)="resetPassword()" class="btn btn-primary"
                            style="background: #ef6603;color: #fff;border-color: #ef6603;">Aceptar</button>
                    </div>
                </form>
            </div>
        </div>
    </div>